
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jVa6Y", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return (parcelRequire("irRyj")).Input; });
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("6nMZs")).InputIcon; });
$parcel$export(module.exports, "Login", function () { return (parcelRequire("lJMiD")).Login; });
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("iTWJZ")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("iTWJZ")).ProviderLogo; });
$parcel$export(module.exports, "Separator", function () { return (parcelRequire("1WLWt")).Separator; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("32ARy")).Social; });
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("l7G9R")).Submit; });
$parcel$export(module.exports, "useAccountCreationContext", function () { return (parcelRequire("cGEBM")).useAccountCreationContext; });
$parcel$export(module.exports, "default", function () { return $4e0aa450913abeb5$export$2e2bcd8739ae039; });

var $6KUQg = parcelRequire("6KUQg");
parcelRequire("1FWHc");
parcelRequire("9ktVo");
var $4e0aa450913abeb5$export$2e2bcd8739ae039 = (0, $6KUQg.AccountCreation);

});
parcelRegister("6KUQg", function(module, exports) {
$parcel$export(module.exports, "AccountCreation", function () { return $42aa4ee4b4afed63$export$b841b541bc741e79; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1FWHc");
var $7u4F3 = parcelRequire("7u4F3");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
const $42aa4ee4b4afed63$export$b841b541bc741e79 = ({ getContinueUrl: getContinueUrl, identityCobranding: identityCobranding, templateId: templateId, ...props })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cGEBM.AccountCreationContextProvider), {
        getContinueUrl: getContinueUrl,
        identityCobranding: identityCobranding,
        templateId: templateId,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7u4F3.Content), {
            ...props
        })
    });

});
parcelRegister("1FWHc", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return (parcelRequire("7u4F3")).Content; });
$parcel$export(module.exports, "Input", function () { return (parcelRequire("irRyj")).Input; });
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("6nMZs")).InputIcon; });
$parcel$export(module.exports, "Login", function () { return (parcelRequire("lJMiD")).Login; });
$parcel$export(module.exports, "Separator", function () { return (parcelRequire("1WLWt")).Separator; });
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("iTWJZ")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("iTWJZ")).ProviderLogo; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("32ARy")).Social; });
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("l7G9R")).Submit; });
parcelRequire("MNUwH");
parcelRequire("f5lYY");
parcelRequire("7PpcD");
parcelRequire("1p00m");
parcelRequire("bncEF");
parcelRequire("1WLWt");
parcelRequire("k0W5w");
parcelRequire("kHTHh");

});
parcelRegister("MNUwH", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return (parcelRequire("7u4F3")).Content; });
parcelRequire("7u4F3");

});
parcelRegister("7u4F3", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $6cc2293976038b02$export$7c6e2c02157bb7d2; });

var $7VQPk = parcelRequire("7VQPk");

var $lX14w = parcelRequire("lX14w");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
parcelRequire("f5lYY");
var $mG5bv = parcelRequire("mG5bv");
parcelRequire("7PpcD");
var $irRyj = parcelRequire("irRyj");
parcelRequire("bncEF");
var $lJMiD = parcelRequire("lJMiD");

var $1WLWt = parcelRequire("1WLWt");
parcelRequire("k0W5w");
var $32ARy = parcelRequire("32ARy");
parcelRequire("kHTHh");
var $l7G9R = parcelRequire("l7G9R");
const $6cc2293976038b02$export$7c6e2c02157bb7d2 = ({ Submit: Submit = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7G9R.Submit), {}), Input: Input = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irRyj.Input), {}), Social: Social = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {}), Separator: Separator = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1WLWt.Separator), {}), Error: Error = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $mG5bv.Error), {}), Login: Login = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJMiD.Login), {}) })=>{
    const { onSubmit: onSubmit } = (0, $cGEBM.useAccountCreationContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                onSubmit: onSubmit,
                isDisabled: false,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                        ...formProps,
                        autoComplete: "off",
                        "data-testid": "account-creation",
                        children: [
                            Input,
                            Submit
                        ]
                    })
            }),
            Error,
            Separator,
            Social,
            Login
        ]
    });
};

});
parcelRegister("9ktVo", function(module, exports) {
$parcel$export(module.exports, "AccountCreationContextProvider", function () { return (parcelRequire("cGEBM")).AccountCreationContextProvider; });
$parcel$export(module.exports, "useAccountCreationContext", function () { return (parcelRequire("cGEBM")).useAccountCreationContext; });
parcelRequire("cGEBM");

});
parcelRegister("cGEBM", function(module, exports) {
$parcel$export(module.exports, "useAccountCreationContext", function () { return $835e146085c3a79b$export$30b295205cfae694; });
$parcel$export(module.exports, "AccountCreationContextProvider", function () { return $835e146085c3a79b$export$b0a1b3550379fc78; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7VwhR = parcelRequire("7VwhR");

var $jmley = parcelRequire("jmley");

var $doAVE = parcelRequire("doAVE");

var $1ka2O = parcelRequire("1ka2O");

var $iSeHD = parcelRequire("iSeHD");
const $835e146085c3a79b$export$52bc2238e0ff8657 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $835e146085c3a79b$export$30b295205cfae694 = ()=>{
    const context = (0, $1oC0p.useContext)($835e146085c3a79b$export$52bc2238e0ff8657);
    if (!context) throw new Error("useAccountCreationContext must be used within a AccountCreationContextProvider");
    return context;
};
const $835e146085c3a79b$export$b0a1b3550379fc78 = ({ getContinueUrl: getContinueUrl, identityCobranding: identityCobranding = "wac", templateId: templateId, children: children })=>{
    const location = (0, $1ka2O.useLocation)();
    const isEmbedded = !location.pathname.endsWith("/try/cloud/signup");
    const { product: product, edition: edition } = (0, $doAVE.useUserContext)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const [isEmailValid, setIsEmailValid] = (0, $1oC0p.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $1oC0p.useState)(false);
    const [isReadyForInvalid, setIsReadyForInvalid] = (0, $1oC0p.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $1oC0p.useState)(false);
    const [formError, setFormError] = (0, $1oC0p.useState)(false);
    const [typeAheadEmail, setTypeAheadEmail] = (0, $1oC0p.useState)("");
    const [tryIntentAnalyticsEventHasFired, setTryIntentAnalyticsEventHasFired] = (0, $1oC0p.useState)(false);
    const localePath = (0, $7VwhR.getLocalePath)(intl.locale);
    const continueParam = (0, $7VwhR.getContinueParam)(location);
    const dataFoundationsActionSubjectId = !!isEmbedded ? "embedded" : "standalone";
    // default experiment params
    if (product && identityCobranding === "wac") {
        if (product.name === "confluence") identityCobranding = "wac--otp-confluence";
        else if (product.name === "jira") identityCobranding = "wac--otp-jira";
        else if (product.name === "loom") identityCobranding = "wac--loom";
        else if (product.name === "jira-product-discovery") identityCobranding = "wac--jpd";
        else if (product.name === "jira-servicedesk") identityCobranding = "wac--jsm";
        else if (product.name === "service-collection") identityCobranding = "wac--service-collection";
        else if (product.name === "teamwork-collection") identityCobranding = "wac--teamwork-collection";
    }
    const defaultContinueUrl = (0, $1oC0p.useCallback)(()=>continueParam ? continueParam : (0, $7VwhR.getNameYourSiteRedirectUrl)({
            bundle: product?.bundle,
            edition: edition,
            localePath: localePath,
            templateId: templateId,
            application: identityCobranding,
            isEmbedded: isEmbedded
        }), [
        continueParam,
        product,
        edition,
        localePath,
        templateId,
        identityCobranding
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!analyticsClient) return;
        (0, $7VwhR.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: product?.key,
            edition: edition
        });
        (0, $7VwhR.ufoEventSignupFormLoad).success({
            customData: {
                webPlatform: "bxp-ui",
                reactComponent: "DefaultSignupForm",
                isLoggedIn: false
            }
        });
        (0, $7VwhR.trackSignFormLoad)(createAnalyticsEvent);
        (0, $7VwhR.trackTimeToFormReady)(createAnalyticsEvent, performance.now());
    }, [
        createAnalyticsEvent,
        edition,
        product?.key,
        dataFoundationsActionSubjectId,
        analyticsClient
    ]);
    const onSubmit = (0, $1oC0p.useCallback)(async ({ email: email })=>{
        setIsReadyForInvalid(true);
        if (!email || !isEmailValid) {
            (0, $7VwhR.trackInvalidEmail)(createAnalyticsEvent);
            return;
        }
        (0, $7VwhR.trackFormSubmit)(createAnalyticsEvent, product?.key, edition);
        setIsSubmitting(true);
        let continueUrl;
        if (getContinueUrl) continueUrl = getContinueUrl();
        if (!continueUrl) continueUrl = defaultContinueUrl();
        try {
            // check identity interstitial redirect experiments for enrollment
            const url = (0, $7VwhR.getIdentityInterstitialUrl)(email, continueUrl, identityCobranding);
            createAnalyticsEvent({
                eventType: "ui",
                action: "succeeded",
                actionSubject: "accountCreationInterstitialRedirect",
                containerId: "bxp-ui-signup",
                attributes: {
                    productKey: product?.key,
                    edition: edition
                }
            }).fire();
            window.location.assign(url);
            return;
        } catch (error) {
            setHasSubmitted(true);
            setFormError(true);
            setIsSubmitting(false);
            createAnalyticsEvent({
                eventType: "ui",
                action: "errored",
                actionSubject: "accountCreationInterstitialRedirect",
                containerId: "bxp-ui-signup",
                attributes: {
                    productKey: product?.key,
                    edition: edition
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        defaultContinueUrl,
        edition,
        getContinueUrl,
        identityCobranding,
        isEmailValid,
        product
    ]);
    const onClickSocialButton = (provider)=>{
        (0, $7VwhR.trackContinueWithSocialSignups)(createAnalyticsEvent, provider, product?.key, edition);
        let continueUrl;
        if (getContinueUrl) continueUrl = getContinueUrl();
        if (!continueUrl) continueUrl = defaultContinueUrl();
        const socialRedirectUrl = (0, $7VwhR.getSocialButtonUrl)({
            redirectTo: continueUrl,
            identityCobranding: identityCobranding,
            provider: provider
        });
        window.location.assign(socialRedirectUrl);
    };
    const onClickSubmitButton = ()=>(0, $7VwhR.trackSubmitButtonClick)(createAnalyticsEvent);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($835e146085c3a79b$export$52bc2238e0ff8657.Provider, {
        value: {
            dataFoundationsActionSubjectId: dataFoundationsActionSubjectId,
            edition: edition,
            formError: formError,
            hasSubmitted: hasSubmitted,
            identityCobranding: identityCobranding,
            isReadyForInvalid: isReadyForInvalid,
            isSubmitting: isSubmitting,
            onClickSocialButton: onClickSocialButton,
            onClickSubmitButton: onClickSubmitButton,
            onSubmit: onSubmit,
            product: product,
            setIsEmailValid: setIsEmailValid,
            setIsReadyForInvalid: setIsReadyForInvalid,
            setTypeAheadEmail: setTypeAheadEmail,
            typeAheadEmail: typeAheadEmail,
            tryIntentAnalyticsEventHasFired: tryIntentAnalyticsEventHasFired
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jmley.default), {
            edition: edition,
            intentType: "form",
            productKey: product?.key,
            onAnalyticsEventFired: ()=>!tryIntentAnalyticsEventHasFired && setTryIntentAnalyticsEventHasFired(true),
            children: children
        })
    });
};

});


parcelRegister("f5lYY", function(module, exports) {
$parcel$export(module.exports, "Error", function () { return (parcelRequire("mG5bv")).Error; });
parcelRequire("mG5bv");

});
parcelRegister("mG5bv", function(module, exports) {
$parcel$export(module.exports, "Error", function () { return $d2f561c370fddce6$export$edf27be85e5f6da0; });
/* error.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
const $d2f561c370fddce6$export$edf27be85e5f6da0 = ({ errorText: errorText })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8e22h.default)();
    const { formError: formError } = (0, $cGEBM.useAccountCreationContext)();
    if (!formError) return null;
    if (errorText === undefined) errorText = locale === "en" // temporary fix until translation is available
     ? formatMessage({
        id: "AccountCreation.userSignupError",
        defaultMessage: `It's taking longer than expected to get you started. Please refresh and try again or <contactUsLink>contact us</contactUsLink>.`
    }, {
        contactUsLink: $d2f561c370fddce6$var$contactUsLink
    }) : formatMessage({
        id: "BxpUiSignup.SignupForm.formError",
        defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>."
    }, {
        contactUsLink: $d2f561c370fddce6$var$contactUsLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        role: "alert",
        className: (0, $2jatx.default)([
            "_syaz1cjc _19pk1j6v _2hwxidpf _otyr1j6v _18u0idpf _3fcw150s"
        ]),
        children: errorText
    });
};
const $d2f561c370fddce6$var$contactUsLink = (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: "/company/contact",
        className: "linkText"
    });
const $d2f561c370fddce6$var$errorCss = null;

});


parcelRegister("7PpcD", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return (parcelRequire("irRyj")).Input; });
parcelRequire("irRyj");

});
parcelRegister("irRyj", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return $5190fd2e8a96a930$export$f5b8910cec6cf069; });
/* input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $7VwhR = parcelRequire("7VwhR");

var $kbpa7 = parcelRequire("kbpa7");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
parcelRequire("1p00m");
var $6nMZs = parcelRequire("6nMZs");
const $5190fd2e8a96a930$var$HELP_TEXT_ID = "account_creation_email_help_text";
const $5190fd2e8a96a930$export$f5b8910cec6cf069 = ({ helpText: helpText, errorMessageText: errorMessageText, labelText: labelText, placeholderText: placeholderText })=>{
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const intl = (0, $8e22h.default)();
    if (helpText === undefined) helpText = intl.formatMessage({
        id: "signupForm.accountCreation.helperText",
        defaultMessage: "Using a work email helps find teammates and boost collaboration."
    });
    if (errorMessageText === undefined) errorMessageText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.invalidEmail",
        defaultMessage: "Please enter a valid email address."
    });
    if (labelText === undefined) labelText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.workEmail",
        defaultMessage: "Work email"
    });
    if (placeholderText === undefined) placeholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.emailPlaceholder",
        defaultMessage: "you@company.com"
    });
    (0, $1oC0p.useEffect)(()=>{
        const isValid = (0, $7VwhR.emailIsValid)(email);
        // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    const team26VisualUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).cfind4831ProductOverlayModalVisualUpdates);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_6rth7vkz _1rwq121t _1heubzd7 _125x1syg _62vcmccc _1d6jidpf _1t2q1kw7 _17rnbzd7 _1q9pbfng _d78pglyw",
            team26VisualUpdates && "_17rnjdj5 _1heujdj5 _1osle4h9"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            label: labelText,
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_7hwb183y",
                        isValid === true && "_olzhaf4m _1osldkaa",
                        isValid === false && "_olzh1wfy _1osldkaa"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                            ...fieldProps,
                            autoComplete: "email",
                            "aria-describedby": $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            elemAfterInput: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nMZs.InputIcon), {
                                valid: isValid
                            }),
                            onBlur: ()=>setIsReadyForInvalid(true),
                            onChange: (e)=>{
                                setEmail(e.target.value);
                                setTypeAheadEmail(e.target.value);
                                fieldProps.onChange(e);
                            },
                            placeholder: placeholderText,
                            testId: "email_field",
                            type: "email",
                            value: email
                        }),
                        isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            role: "alert",
                            className: (0, $2jatx.default)([
                                "_syaz1tmw _1wybepq8 _vwz4bs82 _1pfhi2wt"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $7VwhR.fontSize).xs)
                            },
                            children: errorMessageText
                        }) : helpText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            className: (0, $2jatx.default)([
                                "_1wybepq8 _vwz4bs82 _tzy4txnc _1pfhi2wt"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $7VwhR.fontSize).xs)
                            },
                            children: helpText
                        }) : null
                    ]
                })
        })
    });
};
const $5190fd2e8a96a930$var$errorMessageCss = null;
const $5190fd2e8a96a930$var$helpTextCss = null;
const $5190fd2e8a96a930$var$fieldCss = null;
// todo remove !important when we productionize gate and merge properties with fieldCss
const $5190fd2e8a96a930$var$fieldV2Css = null;
const $5190fd2e8a96a930$var$inputCss = null;
const $5190fd2e8a96a930$var$inputInvalidCss = null;
const $5190fd2e8a96a930$var$inputValidCss = null;

});
parcelRegister("1p00m", function(module, exports) {
$parcel$export(module.exports, "InputIcon", function () { return (parcelRequire("6nMZs")).InputIcon; });
parcelRequire("6nMZs");

});
parcelRegister("6nMZs", function(module, exports) {
$parcel$export(module.exports, "InputIcon", function () { return $f28bd5fc1ae39550$export$f8fea9f50a4bfae6; });
/* input-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kCGk7 = parcelRequire("kCGk7");

var $78jg9 = parcelRequire("78jg9");

var $7VwhR = parcelRequire("7VwhR");

var $kbpa7 = parcelRequire("kbpa7");

var $32ng3 = parcelRequire("32ng3");
const $f28bd5fc1ae39550$export$f8fea9f50a4bfae6 = ({ valid: valid })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const validMessage = formatMessage({
        id: "signupForm.accountCreation.validEmailIcon",
        defaultMessage: "Success"
    });
    const invalidMessage = formatMessage({
        id: "signupForm.accountCreation.invalidEmailIcon",
        defaultMessage: "Warning"
    });
    if (valid === undefined) return null;
    const team26VisualUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).cfind4831ProductOverlayModalVisualUpdates);
    return valid ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswucd5j _1wyb1syg _y4tiftgi _syaz1mps",
            team26VisualUpdates && "_y4ti19bv _w8l5gktf _1752gktf"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78jg9))), {
            label: validMessage
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswucd5j _1wyb1syg _y4tiftgi _syaz1bqt",
            team26VisualUpdates && "_y4ti19bv _w8l5gktf _1752gktf"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $7VwhR.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kCGk7))), {
            label: invalidMessage
        })
    });
};
const $f28bd5fc1ae39550$var$iconWrapperStyle = {
    alignItems: "center",
    display: "flex",
    fill: (0, $kbpa7.wacToken)("color.neutral.light0"),
    fontSize: (0, $7VwhR.fontSize).md,
    paddingInlineEnd: 8
};
const $f28bd5fc1ae39550$var$largerIconCss = null;
const $f28bd5fc1ae39550$var$iconValidCss = null;
const $f28bd5fc1ae39550$var$iconInvalidCss = null;

});




parcelRegister("bncEF", function(module, exports) {
$parcel$export(module.exports, "Login", function () { return (parcelRequire("lJMiD")).Login; });
parcelRequire("lJMiD");

});
parcelRegister("lJMiD", function(module, exports) {
$parcel$export(module.exports, "Login", function () { return $50db90a6da99c80d$export$21a94553ffa41578; });
/* login.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $7VwhR = parcelRequire("7VwhR");

var $2fk4i = parcelRequire("2fk4i");

var $1ka2O = parcelRequire("1ka2O");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
const $50db90a6da99c80d$export$21a94553ffa41578 = ({ loginText: loginText })=>{
    const intl = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    const { product: product } = (0, $cGEBM.useAccountCreationContext)();
    if (loginText === undefined) loginText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.existingProduct",
        defaultMessage: "Already have {product}? <logInLink>Log in</logInLink>"
    }, {
        product: product?.description,
        logInLink: (text)=>$50db90a6da99c80d$var$logInLink(text, location)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_1wyb8oy7 _19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        style: {
            "--_djwknj": (0, $6ZVlx.default)((0, $7VwhR.fontSize).sm)
        },
        children: loginText
    });
};
const $50db90a6da99c80d$var$logInLink = (text, location)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: (0, $7VwhR.getLoginUrl)(location)
    });
const $50db90a6da99c80d$var$existingProductCss = null;

});


parcelRegister("k0W5w", function(module, exports) {
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("iTWJZ")).LogoButton; });
$parcel$export(module.exports, "ProviderLogo", function () { return (parcelRequire("iTWJZ")).ProviderLogo; });
$parcel$export(module.exports, "Social", function () { return (parcelRequire("32ARy")).Social; });
parcelRequire("iTWJZ");
parcelRequire("32ARy");

});
parcelRegister("32ARy", function(module, exports) {
$parcel$export(module.exports, "Social", function () { return $4e2e5c1067955974$export$9a0fadb2797ac9a5; });
/* social.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");

var $iTWJZ = parcelRequire("iTWJZ");
const $4e2e5c1067955974$export$9a0fadb2797ac9a5 = ({ providers: providers })=>{
    const intl = (0, $8e22h.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $cGEBM.useAccountCreationContext)();
    if (providers === undefined) providers = {
        google: "Google",
        microsoft: "Microsoft",
        apple: "Apple",
        slack: "Slack"
    };
    const buttons = Object.entries(providers);
    // when there are 3 buttons, we display in a single row and visually hide the text labels
    const rowStyle = buttons.length === 3;
    /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        role: "list",
        className: (0, $2jatx.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && !rowStyle && "_1e0c11p5 _zulp7vkz _yv0efsjm",
            rowStyle && "_1e0c11p5 _zulp7vkz _wij21bp4"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iTWJZ.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: "social.label.signup",
                        defaultMessage: "sign up with {provider}"
                    }, {
                        provider: label
                    }),
                    onClick: ()=>onClickSocialButton(provider),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iTWJZ.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                rowStyle && "_kqswstnw _1e021cib _152t1wug _1bsbt94y _4t3it94y _1reo15vq _18m915vq _ogtohxbz _o5721q9c"
                            ]),
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};
const $4e2e5c1067955974$var$buttonGridCss = null;
const $4e2e5c1067955974$var$buttonListCss = null;
const $4e2e5c1067955974$var$buttonRowCss = null;
const $4e2e5c1067955974$var$srOnlyCss = null;

});


parcelRegister("kHTHh", function(module, exports) {
$parcel$export(module.exports, "Submit", function () { return (parcelRequire("l7G9R")).Submit; });
parcelRequire("l7G9R");

});
parcelRegister("l7G9R", function(module, exports) {
$parcel$export(module.exports, "Submit", function () { return $9e3c42c7c44204a7$export$2c4cf1f7b42ef78c; });
/* submit.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $5qUgh = parcelRequire("5qUgh");

var $2fk4i = parcelRequire("2fk4i");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("9ktVo");
var $cGEBM = parcelRequire("cGEBM");
const $9e3c42c7c44204a7$export$2c4cf1f7b42ef78c = ({ buttonText: buttonText })=>{
    const intl = (0, $8e22h.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $cGEBM.useAccountCreationContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });
    const modalVisualUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).cfind4831ProductOverlayModalVisualUpdates);
    if (modalVisualUpdates) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: onClickSubmitButton,
        className: (0, $2jatx.default)([
            "_ect41kw7 _1wyb7vkz _p12f1wug _1rjcftgi _1bsb1osq"
        ]),
        children: buttonText
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isFullWidth: true,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: onClickSubmitButton,
        children: buttonText
    });
};
const $9e3c42c7c44204a7$var$buttonCss = null;

});








//# sourceMappingURL=confirmation-page.33e5df55.js.map
